import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'myt-react-snippets';

const CollapseProps = {
	show: PropTypes.bool.isRequired,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

const Collapse = ({ show, children, shadow = true }) => (
	<Transition
		in={show}
		timing={700}
		suffix={{ enter: 'show', exit: '' }}
		onEnter={(target) => {
			target.classList.add("transition")
			target.style.height = 0
		}}
		onEntering={(target) =>
			(target.style.height = `${target.scrollHeight}px`)
		}
		onEntered={(target) => {
			target.classList.remove("transition")
			target.style.height = null
		}}
		onExit={ (target) => {
			target.classList.add("transition")
			target.style.height = `${target.offsetHeight}px`
		}}
		onExiting={(target) => (target.style.height = 0)}
		onExited={(target) => {
			target.classList.remove("transition")
			target.style.height = null
		}}
		allowRef>
		<div className='n-collapse d-block transition' data-shadow={shadow} style={{height: 0}}>
			<div className='n-collapse-content'>{children}</div>
		</div>
	</Transition>
);

Collapse.propTypes = CollapseProps;

export default Collapse;